<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the
project root for license information.
-->

<div mat-dialog-container>
  <div mat-dialog-title>
    {{ data.title }}
    <button mat-icon-button (click)="handleEditComplete(false)" title="Cancel" class="close-button" tabindex="-1">
      <mat-icon class="mdi-24px self-center" fontIcon="mdi-close-circle-outline"></mat-icon>
    </button>
  </div>
  @if (data && data.playerApplication) {
  <div mat-dialog-content>
    <div class="add-margin">
      <div>
        <mat-form-field class="full-width">
          <mat-label>Name</mat-label>
          <input type="text" matInput [(ngModel)]="data.playerApplication.name" placeholder="Name">
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <b>Parameters can be used in the following URLs (include the braces):</b> <br />
      {{ '{citeUrl}, {galleryUrl}, {steamfitterUrl}, {playerUrl}, {blueprintUrl}' }} <br />
      {{ '{citeEvaluationId}, {galleryExhibitId}, {steamfitterScenarioId}, {playerViewId}, {blueprintMselId}' }}<br />
      <b>For example:</b><br />
      {{ '{galleryUrl}?section=archive&exhibit={galleryExhibitId}{theme}' }}<br />
      {{ '{galleryUrl}/assets/img/archive-blue.png' }}<br />
      &nbsp;
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="full-width">
          <mat-label>URL</mat-label>
          <input type="text" matInput [(ngModel)]="data.playerApplication.url" placeholder="URL">
        </mat-form-field>
      </div>
    </div>
    <div class="add-icon-url-margin">
      <div>
        <mat-form-field class="full-width">
          <mat-label>Icon URL</mat-label>
          <input type="text" matInput [(ngModel)]="data.playerApplication.icon" placeholder="Icon URL">
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-checkbox [(ngModel)]="data.playerApplication.embeddable">Embeddable</mat-checkbox>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-checkbox [(ngModel)]="data.playerApplication.loadInBackground">Load in Background</mat-checkbox>
      </div>
    </div>
  </div>
  }
  <div class="cssLayoutRowStartCenter bottom-button">
    <div class="delete-button">
      <button mat-stroked-button (click)="handleEditComplete(true)" style="margin-left: 40px;">Save</button>
    </div>
    <div class="delete-button">
      <button mat-stroked-button (click)="handleEditComplete(false)">Cancel</button>
    </div>
  </div>
</div>
